import { motion } from "framer-motion";
import { Video, Clapperboard, Film, Sparkles, Check } from "lucide-react";
import { IMAGES } from "@/data/content";

const FEATURES = [
  "Reels y contenido vertical para redes",
  "Vídeos corporativos y de marca",
  "Guion, grabación y edición completa",
  "Equipo y material profesional",
];

export const VideoProduction = () => {
  return (
    <section
      id="video"
      data-testid="video-section"
      className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20 md:py-32"
    >
      <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
          className="relative rounded-3xl overflow-hidden aspect-[4/5] sm:aspect-[4/3] lg:aspect-[4/5] order-2 lg:order-1"
        >
          <img
            src={IMAGES.videoProd}
            alt="Grabación de contenido y vídeos corporativos"
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-forest/70 via-transparent to-transparent" />
          <div className="absolute top-5 left-5 flex items-center gap-2 rounded-full bg-mango text-ink text-xs font-bold px-4 py-2">
            <Clapperboard size={15} />
            Producción audiovisual
          </div>
        </motion.div>

        <div className="order-1 lg:order-2">
          <p className="flex items-center gap-2 text-xs font-bold tracking-[0.25em] uppercase text-green mb-5">
            <Video size={16} /> Grabamos por ti
          </p>
          <h2 className="font-display font-black text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-[0.92]">
            Grabamos tu contenido y tus{" "}
            <span className="text-green">vídeos corporativos</span>.
          </h2>
          <p className="mt-6 text-ink/65 text-base md:text-lg max-w-lg leading-relaxed">
            Nos encargamos de todo el proceso: desde la idea hasta el vídeo final.
            Contenido fresco y profesional que transmite la esencia de tu marca y
            conecta con tu audiencia.
          </p>

          <ul className="mt-8 grid sm:grid-cols-2 gap-4">
            {FEATURES.map((f, i) => (
              <motion.li
                key={i}
                initial={{ opacity: 0, y: 15 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.08 }}
                data-testid={`video-feature-${i}`}
                className="flex items-start gap-3"
              >
                <span className="mt-0.5 grid place-items-center h-6 w-6 shrink-0 rounded-full bg-green text-ink">
                  <Check size={14} strokeWidth={3} />
                </span>
                <span className="text-ink/80 text-sm md:text-base">{f}</span>
              </motion.li>
            ))}
          </ul>

          <div className="mt-8 inline-flex items-center gap-2 rounded-2xl bg-cream border border-ink/10 px-5 py-3 text-sm text-ink/70">
            <Film size={18} className="text-green" />
            Reels, spots y contenido listo para publicar
            <Sparkles size={16} className="text-mango" />
          </div>
        </div>
      </div>
    </section>
  );
};
